(async () => {
    const { Core } = await importModule('Core');
    const { $toggleDisplay } = await importModule('Utils');

    const ATTR_MONEY_TEMPLATE = "money-template";
    const ATTR_MAIN_VARIANT_PRICE = "main-variant-price";
    const ATTR_SHOW_TOTAL = 'show-total';

    customElements.define('product-buy-with', class extends Core {
        elements = {
            items: '*[data-element="complementary-item"]',
            subtotal :'[data-element="subtotal"]',
            subtotalPrice :'[data-element="subtotal-price"]',
            quantitySelectors: '*[data-element="complementary-item-quantity"]',
        }

        subscriptions = {
            'cart:update':  '_uncheck'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this._handleChange();
            this._setupQuantityButtons();
            this._setupCheckboxToggle();
        }

        _setupCheckboxToggle() {
            const checkboxes = document.querySelectorAll('.product-buy-with-qty-adjust input[type="checkbox"][data-element="complementary-item"]');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', (event) => {
                    const variantId = event.target.value;
                    const qtyWrapper = document.querySelector(`#product-buy-with-qty-wrapper-${variantId}`);
            
                    if (qtyWrapper) {
                        qtyWrapper.style.display = checkbox.checked ? 'flex' : 'none';
                    }
                });

                const variantId = checkbox.value;
                const qtyWrapper = document.querySelector(`#product-buy-with-qty-wrapper-${variantId}`);
                if (qtyWrapper) {
                    qtyWrapper.style.display = checkbox.checked ? 'flex' : 'none';
                }
            });
        }

        _handleChange() {
            this.addEventListener('change', (event) => {
                if (event.target && event.target.dataset.element === "complementary-item") {
                    console.log('Checkbox Changed:', {
                        id: event.target.value,
                        checked: event.target.checked
                    });
                }
            });
            this.addEventListener('input', this._onQuantityChange.bind(this));
        }

        _setupQuantityButtons() {
            const quantitySelectors = document.querySelectorAll(this.elements.quantitySelectors);
            
            quantitySelectors.forEach(selector => {
                const variantId = selector.id.replace('qty-display-', '');
                const qtyWrapper = document.querySelector(`#product-buy-with-qty-wrapper-${variantId}`) || selector.closest('.product-buy-with-qty-wrapper');

                if (!qtyWrapper) {
                    console.warn('Quantity wrapper not found for selector:', selector);
                    return;
                }

                const decreaseBtn = qtyWrapper.querySelector(`product-buy-with-qty-button[data-variant-id="${variantId}"].product-buy-with-qty-minus`);
                const increaseBtn = qtyWrapper.querySelector(`product-buy-with-qty-button[data-variant-id="${variantId}"].product-buy-with-qty-plus`);
                const quantityInput = qtyWrapper.querySelector(`#qty-input-${variantId}`);
                const quantityDisplay = selector; // Use selector directly for quantity display

                if (!decreaseBtn || !increaseBtn || !quantityInput || !quantityDisplay) {
                    console.warn('Missing element(s) in quantity wrapper:', qtyWrapper);
                    return;
                }

                decreaseBtn.addEventListener('click', () => {
                    let currentValue = parseInt(quantityInput.value, 10);
                    quantityInput.value = Math.max(currentValue - 1, 0);
                    quantityDisplay.innerText = quantityInput.value;

                    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                    this._onQuantityChange({ target: quantityInput });
                });

                increaseBtn.addEventListener('click', () => {
                    let currentValue = parseInt(quantityInput.value, 10);
                    quantityInput.value = currentValue + 1;
                    quantityDisplay.innerText = quantityInput.value;

                    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                    this._onQuantityChange({ target: quantityInput });
                });
            });
        }

        _onChange() {      
            this._getCurrentItems();
            this.showTotal && this._updateSubtotal();
            this._publishChange();
        } 

        _onQuantityChange(event) {
            const quantityInput = event.target;
            if (quantityInput.dataset.element === 'complementary-item-quantity' || quantityInput.name === 'quantity') {
                const variantId = quantityInput.id.replace('qty-input-', '');
                const qtyWrapper = document.querySelector(`#product-buy-with-qty-wrapper-${variantId}`) || quantityInput.closest('.product-buy-with-qty-wrapper');
                if (qtyWrapper) {
                    const quantityDisplay = qtyWrapper.querySelector(`#qty-display-${variantId}`) || qtyWrapper.querySelector('.product-buy-with-qty-display');
                    if (quantityDisplay) {
                        quantityDisplay.innerText = quantityInput.value;
                    }

                    const decreaseBtn = qtyWrapper.querySelector(`#product-buy-with-qty-minus-${variantId}`);
                    const minQty = parseInt(quantityInput.getAttribute('min'), 10) || 1; // Default minimum quantity is 1 if not set

                    if (parseInt(quantityInput.value, 10) <= minQty) {
                        decreaseBtn.setAttribute('disabled', 'true');
                    } else {
                        decreaseBtn.removeAttribute('disabled');
                    }
                }
                this._getCurrentItems();
                this.showTotal && this._updateSubtotal();
                this._publishChange();
            }
        }

        _getCurrentItems() {
            this.checkedItems = this.$items.filter(item => item.checked).map(item => {
                const quantityInput = document.querySelector(`#qty-input-${item.value}`) 
                    || item.closest('.product-buy-with-qty-wrapper').querySelector('.product-buy-with-qty-input');
                const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

                return {
                    variantId: item.value,
                    quantity: quantity
                };
            });
        }

        _uncheck() {
            if (this.checkedItems && Array.isArray(this.checkedItems)) {
                this.checkedItems.map($checkbox => {
                    $checkbox.checked = false;
                });
            } else {
                console.warn('checkedItems is undefined or not an array');
            }
            $toggleDisplay(this.$subtotal, false);
            this._getCurrentItems();
            this._publishChange();
        }

        _publishChange() {
            this.publish('buyWith:change', { 
                selected: this.checkedItems.length
            })
        }

        _updateSubtotal() {
            this._getSubtotalWithCurrency();
            this.$subtotalPrice.innerText = this.subtotalWithCurrency;
            $toggleDisplay(this.$subtotal, !!this.checkedItems.length);
        }

        _getSubtotalWithCurrency() {
            this.subtotalWithCurrency = this.moneyTemplate.replace('{amount}', this.subtotalValue);
        }
    
        get subtotalValue() {
            return this.checkedItems
                    .map(item => item.quantity * +item.dataset.priceValue)
                    .reduce((acc, price) => acc += price, +this.mainVariantPrice)
                    .toLocaleString(undefined, {minimumFractionDigits: 2})
        }

        get mainVariantPrice() {
            return this.getAttribute(ATTR_MAIN_VARIANT_PRICE);
        }

        get moneyTemplate() {
            return this.getAttribute(ATTR_MONEY_TEMPLATE);
        }

        get showTotal() {
            return this.hasAttribute(ATTR_SHOW_TOTAL);
        }
    })
})();
